import { createEntityAdapter, createSlice, EntityState } from "@reduxjs/toolkit";
import { AppId } from "../../app/appTypes";
import { RootState } from "../../app/store";
import { MeasurmentType } from "./types";

export interface Sensor {
    id: AppId,
    name: string,
    producer: string,
    calibrationDate: string | null,
    measurmentTypes: MeasurmentType[],
}

export type DraftSensor = Omit<Sensor, "id">

const adapter = createEntityAdapter<Sensor>({
    selectId: (sensor) => sensor.id,
})

export type SensorsState = EntityState<Sensor>

const initialState: SensorsState = adapter.setAll(adapter.getInitialState(), [
    {
        id: 'sensor-1',
        name: 'Particle Counter PC-3000',
        producer: 'TSI Incorporated',
        calibrationDate: '2025-11-15',
        measurmentTypes: ['particles-in-air'],
    },
    {
        id: 'sensor-2',
        name: 'Thermo-Hygrometer TH-200',
        producer: 'Vaisala',
        calibrationDate: '2025-09-30',
        measurmentTypes: ['temp-and-humidity'],
    },
    {
        id: 'sensor-3',
        name: 'Differential Pressure Gauge DP-500',
        producer: 'Dwyer Instruments',
        calibrationDate: '2026-01-20',
        measurmentTypes: ['pressure-difference'],
    },
    {
        id: 'sensor-4',
        name: 'Anemometer AE-100',
        producer: 'Testo',
        calibrationDate: '2025-12-05',
        measurmentTypes: ['air-exchange-rate'],
    },
    {
        id: 'sensor-5',
        name: 'Lux Meter LM-400',
        producer: 'Konica Minolta',
        calibrationDate: null,
        measurmentTypes: ['light-intensity'],
    },
])

export const sensorsSlice = createSlice({
    name: "sensors",
    initialState,
    reducers: {
        addSensor: adapter.addOne,
        updateSensor: adapter.updateOne,
        removeSensor: adapter.removeOne,
    },
})

export const { addSensor, updateSensor, removeSensor } = sensorsSlice.actions

export const selectSensors = (state: RootState): SensorsState => state.sensors

export const
    { selectAll: selectAllSensors
    , selectById: selectSensorById
    } = adapter.getSelectors<RootState>(selectSensors)

export default sensorsSlice.reducer
